// src/utils/loadRoles.js
import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "../firebase";

const title = (s = "") =>
  s.toLowerCase().split(" ").filter(Boolean)
    .map(w => w[0].toUpperCase() + w.slice(1)).join(" ");

function dedupeSort(names) {
  return [...new Set(names.filter(Boolean).map(title))]
    .sort((a, b) => a.localeCompare(b));
}

function isArchivedDoc(d) {
  const hasArchivedAt = !!d?.archivedAt;
  const explicitFalse = d?.archived === false || d?.isArchived === false;
  return d?.archived === true || d?.isArchived === true || (hasArchivedAt && !explicitFalse);
}

function cacheKey(orgId, storeId) {
  return `kiosk.roles.${orgId || "noorg"}.${storeId || "nostore"}`;
}

export function invalidateRolesCache(orgId, storeId) {
  try { localStorage.removeItem(cacheKey(orgId, storeId)); } catch {}
}

export async function loadRolesForKiosk(inputOrgId, inputStoreId) {
  const orgId = inputOrgId || localStorage.getItem("orgId") || "";
  const storeId = inputStoreId || localStorage.getItem("storeId") || "";

  // Short cache so archive/restore reflects quickly (Refresh button can force invalidation too)
  try {
    const raw = localStorage.getItem(cacheKey(orgId, storeId));
    if (raw) {
      const { at, data } = JSON.parse(raw);
      if (Date.now() - at < 20 * 1000 && Array.isArray(data) && data.length) {
        console.log("[kiosk] roles (cache):", data);
        return data;
      }
    }
  } catch {}

  const names = [];

  const pull = async (ref) => {
    try {
      const snap = await getDocs(ref);
      return snap.docs
        .map((d) => ({ id: d.id, ...(d.data() || {}) }))
        .filter((d) => !isArchivedDoc(d))
        .map((d) => d.name || d.label || "");
    } catch {
      return [];
    }
  };

  if (orgId) {
    // org-scoped roles collection
    const a = await pull(collection(db, "orgs", orgId, "cashup_roles"));
    if (a.length) {
      const ok = dedupeSort(a);
      console.log("[kiosk] roles:", ok);
      localStorage.setItem(cacheKey(orgId, storeId), JSON.stringify({ at: Date.now(), data: ok }));
      return ok;
    }
  }

  // root by store
  if (storeId) {
    const byStore = await pull(query(collection(db, "cashup_roles"), where("storeId", "==", storeId)));
    if (byStore.length) names.push(...byStore);
  }

  // root by org
  if (orgId) {
    const byOrg = await pull(query(collection(db, "cashup_roles"), where("orgId", "==", orgId)));
    if (byOrg.length) names.push(...byOrg);
  }

  const finalNames = dedupeSort(names).length
    ? dedupeSort(names)
    : ["Cashier", "Floor Runner", "Packer"];
  console.log("[kiosk] roles:", finalNames);

  try {
    localStorage.setItem(cacheKey(orgId, storeId), JSON.stringify({ at: Date.now(), data: finalNames }));
  } catch {}

  return finalNames;
}
